import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const complianceCategories = [
  {
    title: 'State Requirements',
    items: ['AB 1482 Rent Control', 'Security Deposit Limits', 'Just Cause Eviction', 'Tenant Rights Notice'],
  },
  {
    title: 'Health & Safety',
    items: ['Lead Paint (EPA)', 'Asbestos Warning', 'Mold Information', 'Bed Bug Disclosure'],
  },
  {
    title: 'Property Info',
    items: ['Utilities Disclosure', 'Shared Utilities', 'Gas/Electric Info', 'Water Submeter'],
  },
  {
    title: 'Environmental',
    items: ['Flood Hazard Zone', 'Military Base Noise', 'Wildfire Risk Area', 'Earthquake Fault'],
  },
];

const LegalComplianceSection: React.FC = () => {
  return (
    <SectionBackground className="features" style={{ padding: '80px 16px' }}>
      <div className="container">
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: 60, fontWeight: 700 }}>
          Review the Common California Disclosures
        </h2>
        <div style={{
          background: '#FEF3C7',
          padding: '40px',
          borderRadius: '16px',
          marginBottom: '40px',
        }}>
          <div style={{ textAlign: 'center', fontSize: '1.2rem', color: '#92400E', fontWeight: 600 }}>
            ⚠️ Use this as a checklist of typical California requirements. Some items may not apply to your property—check local rules before finalizing.
          </div>
        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '16px',
          maxWidth: '1200px',
          margin: '0 auto',
        }}>
          {complianceCategories.map((category, idx) => (
            <div
              key={idx}
              style={{
                padding: '20px',
                background: 'var(--bg-light)',
                borderRadius: '8px',
                height: '100%',
              }}
            >
              <div style={{ color: 'var(--primary)', marginBottom: '10px', fontWeight: 600 }}>
                {category.title}
              </div>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {category.items.map((item, itemIdx) => (
                  <li key={itemIdx} style={{ fontSize: '0.9rem', color: 'var(--text-light)', lineHeight: 1.6 }}>
                    ✓ {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p style={{ textAlign: 'center', marginTop: '24px', color: '#4B5563' }}>
          TenantTerms surfaces these items for convenience; requirements can vary by property and location.
        </p>
      </div>
    </SectionBackground>
  );
};

export default LegalComplianceSection; 
